module.exports = __webpack_public_path__ + "static/media/HelveticaNikePlus_Light.cd194dc7.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/HelveticaNikePlus/HelveticaNikePlus_Light.otf
// module id = 885
// module chunks = 0